import * as React from 'react';
import { Table, Button, Modal, FormControl } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';

interface ISourceCodeModalProps {
    content: string;
    close: (content?: string) => void;
}

class SourceCodeModal extends React.Component<ISourceCodeModalProps, any> {
    constructor(props: ISourceCodeModalProps) {
        super(props);

        this.state = {
            sourceCode: ''
        };

        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
        this.close = this.close.bind(this);
    }

    componentDidMount() {
        if (this.props.content) {
            this.setState({ sourceCode: this.props.content });
        }
    }

    onChange(e) {
        this.setState({ sourceCode: e.target.value });
    }

    render() {
        return (
            <Modal show={true} onHide={this.close} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{Translate('templates/modal/title/templates')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <FormControl
                            componentClass="textarea"
                            rows={20}
                            value={this.state.sourceCode}
                            onChange={this.onChange}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>
                        {Translate('templates/modal/footer/button-label/close')}
                    </Button>
                    <Button bsStyle="primary" onClick={this.save}>
                        {Translate('templates/modal/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    close() {
        this.props.close();
    }

    save() {
        this.props.close(this.state.sourceCode);
    }
}

export default SourceCodeModal;
